import { deSentimentWordConfig } from './de';
import { enSentimentWordConfig } from './en';
import { esSentimentWordConfig } from './es';
import { frSentimentWordConfig } from './fr';
import { itSentimentWordConfig } from './it';
import { jaSentimentWordConfig } from './ja';
import { koSentimentWordConfig } from './ko';
import { nlSentimentWordConfig } from './nl';
import { plSentimentWordConfig } from './pl';
import { ptSentimentWordConfig } from './pt';
import { ruSentimentWordConfig } from './ru';
import { SentimentWordConfig } from './types';
import { zhSentimentWordConfig } from './zh';

export const SENTIMENT_WORD_CONFIGS: Record<string, SentimentWordConfig> = {
    de: deSentimentWordConfig,
    en: enSentimentWordConfig,
    es: esSentimentWordConfig,
    fr: frSentimentWordConfig,
    it: itSentimentWordConfig,
    ja: jaSentimentWordConfig,
    ko: koSentimentWordConfig,
    nl: nlSentimentWordConfig,
    pl: plSentimentWordConfig,
    pt: ptSentimentWordConfig,
    ru: ruSentimentWordConfig,
    zh: zhSentimentWordConfig,
};

export type { SentimentWordConfig } from './types';
